import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { SlotTemplateClient } from '@frontend/slot/api';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useSlotTemplate:request': CustomEvent<string>;
    }
}

const REQUEST_EVENT = 'useSlotTemplate:request';
const STORAGE_KEY = 'SLT_TMP_REQ';

export function slotTemplateRequest(id: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_EVENT, { detail: id }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function SlotTemplateResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_EVENT, EntityType.SLOT_TEMPLATE, (ids) => SlotTemplateClient.resolveSlotTemplates(ids), props.dispatch);
    return <></>;
}
